'use strict';

angular.module("ufcw")
  .filter('time', function($filter) {
    return function(input) {
     var date = new Date('1970-01-01 '+input);
      return($filter('date')(date, 'HH:mm') );
    }
  });
